module.exports = __webpack_public_path__ + "media/images/frontend/heros/gallery-c1c1b30cd521b60e8951613c300e720f.jpg";